var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGreyPencil = function SvgGreyPencil(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13.707,
    height: 13.664,
    viewBox: "0 0 13.707 13.664",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_1271910_cc",
    transform: "matrix(0.995, 0.105, -0.105, 0.995, 1.246, -0.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9917",
    "data-name": "Path 9917",
    d: "M7.592.754.618,7.729A.433.433,0,0,0,.5,7.973L0,11.441a.433.433,0,0,0,.433.494H.492L4.014,11.5a.433.433,0,0,0,.254-.124L11.233,4.4A2.575,2.575,0,1,0,7.592.754ZM3.749,10.648.932,11l.394-2.761L7.354,2.217,9.77,4.634Zm6.87-6.866-.238.238L7.967,1.606l.238-.238A1.708,1.708,0,0,1,10.62,3.782Z",
    transform: "translate(0.625 0) rotate(3)",
    fill: "#afafaf"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGreyPencil, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/greyPencil.863bd021.svg";
export { ForwardRef as ReactComponent };